import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import s from './ServiceSection.scss';
import { Button, TextButton, Text } from 'wix-style-react';

class ServiceSection extends React.Component {
  static propTypes = {
    t: PropTypes.func,
    onGetQuoteClick: PropTypes.func,
    service: PropTypes.object,
    showButton: PropTypes.bool,
  };

  render() {
    const { t, service, onGetQuoteClick, showButton } = this.props;
    const { legacyServiceId, legacyTypeId, name } = service;

    return (
      <div className={s.innerServiceContainer}>
        <div className={s.details}>
          {showButton ? (
            <TextButton
              dataHook={`service-name-link-${legacyServiceId}-${legacyTypeId}`}
              as="a"
              weight="normal"
              onClick={() => onGetQuoteClick(legacyServiceId, legacyTypeId)}
            >
              {t(`client-exploreservices-${name}-label`)}
            </TextButton>
          ) : (
            <Text size="medium" skin="standard" tagName="span" weight="normal">
              {t(`client-exploreservices-${name}-label`)}
            </Text>
          )}
          <Text size="medium" skin="standard" tagName="span" weight="normal">
            {`  |  ${t('client-explore-profile-service-starting-at', {
              budgetMin: service.minPrice.toLocaleString(),
            })}`}
          </Text>
          <Text size="small" skin="standard" tagName="div" weight="thin">
            {t(`client-exploreservices-${name}-description`)}
          </Text>
        </div>
        {showButton && (
          <Button
            dataHook="get-quote-button"
            className={s.getQuoteButton}
            priority="secondary"
            size="small"
            skin="standard"
            onClick={() => onGetQuoteClick(legacyServiceId, legacyTypeId)}
          >
            {t('client-explore-profile-service-cta-button')}
          </Button>
        )}
      </div>
    );
  }
}

export default translate()(ServiceSection);
